import React from 'react'

interface BookingCategoryRadioOptionProps {
  titleText: string
  bodyText: string
  backgroundImage: string
  selected: boolean
  onSelect: () => void
  selectedBorderColor: string
  Icon: React.ComponentType<{ fill: string; className: string }>
}

export const BookingCategoryRadioOption = ({
  titleText,
  bodyText,
  backgroundImage,
  selected,
  onSelect,
  selectedBorderColor,
  Icon,
}: BookingCategoryRadioOptionProps) => {
  const optionShadow = 'shadow-[0px_3px_10px_0px_#205497]'

  return (
    <label
      className={`w-[186px] md:w-[240px] h-[150px] md:h-[198px] shadow-md rounded-xl overflow-hidden cursor-pointer bg-cover bg-center !py-4 !px-3 md:!py-5 hover:${optionShadow} ${selected ? optionShadow : ''
        }`}
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      <input
        type='radio'
        name='bookingType'
        checked={selected}
        onChange={onSelect}
        className='absolute opacity-0 w-0 h-0'
      />
      <div
        className={`flex flex-col gap-1 md:gap-2 backdrop-blur border rounded-[4px] bg-rgba(255, 255, 255, 0.1) w-full p-4 ${selected ? selectedBorderColor : 'border-white'
          }`}
      >
        <Icon fill='#122D5C' className='h-4 w-4 md:h-6 md:w-6' />
        <h4 className='text-[#122D5C] text-sm md:text-base md:font-medium tracking-wide'>
          {titleText}
        </h4>
        <p className='text-[#37455C] text-[10px] md:text-sm font-normal tracking-wide'>
          {bodyText}
        </p>
      </div>
    </label>
  )
}
